<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box register">

            <div class="container register step2">
				<div class="title">
					<h1>{{$t('TITLE.EUR.SIGNUP.REQUEST')}}</h1>
				</div>
				<div class="content" ng-init="">
					<div class="one-register">

                        <div class="register_step">
                            <ul>
                                <li>
                                    <em>1</em>
                                    <p>{{$t('TITLE.EUR.TERMS')}}</p>
                                </li>
                                <li class="active"><!-- 활성화 STEP class -->
                                    <em>2</em>
                                    <p>{{$t('TITLE.EUR.SIGN.UP')}}</p>
                                </li>
                                <li>
                                    <em>3</em>
                                    <p>{{$t('BUTTON.GLOBAL.REQUEST')}}</p>
                                </li>
                            </ul>
                        </div>

                        <div class="input-rows">
                            <fieldset class="step_set">
                                <div class="one-input-container">
                                    <label>{{$t('FIELD.EUR.YOUR.COUNTRY')}} / {{$t('FIELD.GLOBAL.LANGUAGE')}}</label>
                                    <input type="text" v-model="countryLangNm" autocomplete="off" readonly>
                                </div>
                                <div class="one-input-container userEmail">
                                    <label for="idUserEmail">{{$t('FIELD.GLOBAL.ID')}}({{$t('FIELD.GLOBAL.EMAIL')}})</label>
                                    <input id="idUserEmail" type="text" v-model="email" autocomplete="off" readonly>
                                </div>
                                <div class="one-input-container companyNm">
                                    <label for="idCompanyNm">{{$t('FIELD.PROFILE.COMPANY.NAME')}} *</label>
                                    <input id="idCompanyNm" type="text" ref="compNm" v-model="companyNm" maxlength="50" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.COMP.NAME')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container companyNo">
                                    <label for="idCompanyNo">{{$t('FIELD.COMPANY.REGISTRATION.NUMBER')}} *</label>
                                    <input id="idCompanyNo" type="text" v-model="companyNo" maxlength="30" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.COMP.REGNO')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container address">
                                    <label for="idAddress">{{$t('FIELD.EUR.COMP.ADDR')}} *</label>
                                    <input id="idAddress" type="text" v-model="address" maxlength="90" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.COMP.ADDRESS')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container zipCd">
                                    <label for="idZipCd">{{$t('FIELD.POSTAL.CODE')}} *</label>
                                    <input id="idZipCd" type="text" v-model="zipCd" maxlength="10" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.ZIP.CODE')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container homeUrl">
                                    <label for="idHomeUrl">{{$t('FIELD.COMPANY.WEBSITE.ADDRESS')}}</label>
                                    <input id="idHomeUrl" type="text" v-model="homeUrl" maxlength="40" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.WEB.URL')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container contactFrstNm">
                                    <label for="idContactFrstNm">{{$t('FIELD.EUR.FIRST.NAME')}} *</label>
                                    <input id="idContactFrstNm" type="text" v-model="contactFrstNm" maxlength="20" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.FIRST.NAME')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container contactLastNm">
                                    <label for="idContactLastNm">{{$t('FIELD.EUR.LAST.NAME')}} *</label>
                                    <input id="idContactLastNm" type="text" v-model="contactLastNm" maxlength="20" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.LAST.NAME')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container contactPhoneNo">
                                    <label for="idContactPhone">{{$t('FIELD.CONTACT.PHONE.NUMBER')}} *</label>
                                    <input id="idContactPhone" type="text" v-model="contactPhoneNo" maxlength="20" @keyup="onlyNumber2($event)" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.PHONE.NO')}}</div>
                                    </div>
                                </div>
                                <div class="one-input-container apeCodes">
                                    <label for="idApeCodes">{{$t('FIELD.EUR.APE.CODES')}} ({{$t('FIELD.EUR.FRANCE.ONLY')}}) <span v-if="loginCountryCd == 'FR'">*</span></label>
                                    <input id="idApeCodes" type="text" v-model="apeCodes" maxlength="99" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.APE.CODE')}}</div>
                                    </div>
                                </div>

                                <div class="one-input-container file-input attachFile1">
                                    <label v-if="loginCountryCd == 'DE' && langCd == 'de'" for="idAttachFile1">
                                        Eintrag Handwerksrolle oder IHK Eintrag (bitte Datei anhängen) *
                                    </label>
                                    <label v-else for="idAttachFile1">{{$t('FIELD.INSURANCE.POLICY')}} *</label>
                                    <input id="idAttachFile1" type="text" class="upload_text" readonly="readonly" maxlength="30" autocomplete="off">
                                    <div class="upload-btn_wrap">
                                        <button type="button" title="Find file"><span>{{$t('BUTTON.EUR.BROWSER')}}</span></button>
                                        <input type="file" id="file1" class="input_file" @change="fileUpload($event, 1)" title="Find file">
                                    </div>
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.POLICY.FILE')}}</div>
                                    </div>
                                </div>

                                <div class="one-input-container file-input attachFile2">
                                    <label for="idAttachFile2">{{$t('FIELD.COMPANY.REGISTRATION.FILE')}} *</label>
                                    <div class="upload-btn_wrap">
                                        <button type="button" title="Find file"><span>{{$t('BUTTON.EUR.BROWSER')}}</span></button>
                                        <input type="file" id="file2" class="input_file" @change="fileUpload($event, 2)" title="Find file">
                                    </div>
                                    <input id="idAttachFile2" type="text" class="upload_text" readonly="readonly" maxlength="30" autocomplete="off">
                                    <div class="error-msg">
                                        <div class="ng-hide">{{$t('MESSAGE.EUR.WARNING.COMP.REG.FILE')}}</div>
                                    </div>
                                </div>
                                <div class="check-msg">{{$t('MESSAGE.EUR.FILE.LESS.10MB')}}<br/>{{$t('MESSAGE.EUR.MENDTR.FIELD')}}</div>
                            </fieldset>
                        </div>

                        <div class="one-btn-wrap">
                            <button class="bt-type-b" @click="goBackStep1">{{$t('BUTTON.GLOBAL.BACK')}}</button>
                            <button class="bt-type-b next" @click="handleJoinSubmit">{{$t('BUTTON.GLOBAL.NEXT')}}</button>
                        </div>

					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import Vue              from 'vue';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import qs               from 'query-string';
import axios            from 'axios';
import store            from '@/vuex/store';
import ConfirmPopup     from './JoinedConfirmPopup';
import { i18n, loadLanguageAsync } from '@/i18n';

export default {
    name: 'EurJoinUserStep2',
    computed: {
        ...mapGetters({
            guid      : 'getGuid',    // GUID
            email     : 'getEmail',
            loginCountryCd : 'getLoginCountryCd',
            langCd    : 'getLangCd'
        })
    },
    data() {
        return {
            langNm: '',
            countryNm : '',
            countryLangNm : '',
            langNm : '',
            companyNm: '',
            companyNo: '',
            zipCd: '',
            address: '',
            homeUrl: '',
            contactFrstNm: '',
            contactLastNm: '',
            contactPhoneNo: '',
            apeCodes: '',
            attachFile1Name: '', // Insurance Cetificate Name
            attachFile1Size: '', // Insurance Cetificate Size
            attachFile2Name: '', // Company Regist License Name
            attachFile2Size: '', // Company Regist License Size
            countryCdList: [],
            langCdList: []
        };
    },
    methods: {
        // validation
        userValidateion() {
            let bRes = true;

            if (this.companyNo.length < 5) {
                $('.userEmail').removeClass('error');
                $('.companyNo').addClass('error');
                return false;
            }

            let valids  = [this.companyNm, this.companyNo, this.address, this.zipCd, this.contactFrstNm
                         , this.contactLastNm, this.contactPhoneNo, this.attachFile1Name, this.attachFile2Name];
            let classNm = ['companyNm', 'companyNo', 'address', 'zipCd', 'contactFrstNm', 'contactLastNm'
                         , 'contactPhoneNo', 'attachFile1', 'attachFile2'];
            if (this.loginCountryCd == 'FR') { // 프랑스일 때만 APE Codes 체크
                valids.push(this.apeCodes);
                classNm.push('apeCodes');
            }
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    $('.' + classNm[idx]).addClass('error');
                    bRes = false;
                    return false;
                } else {
                    $('.' + classNm[idx]).removeClass('error');
                }
            });

            let fileTotalSize = (Number(this.attachFile1Size) + Number(this.attachFile2Size)) / 1000;
            if (fileTotalSize > 10000) {
                SDLUtil.alert('MESSAGE.EUR.FILE.LESS.10MB');
                bRes = false;
            }

            if (this.attachFile1Name && this.attachFile2Name && this.attachFile1Name == this.attachFile2Name) {
                SDLUtil.alert('MESSAGE.EUR.DUP.FILE.NAME');
                bRes = false;
            }

            return bRes;
        },
        async handleJoinSubmit() {

            if (!this.userValidateion()) {
                return;
            }
            SDLUtil.showLoadingBar(true);
  
            let joinData = {
                guid            : this.guid,
                countryCd       : this.loginCountryCd,
                langCd          : this.langCd,
                userEmail       : this.email,
                companyNo       : this.companyNo,
                companyNm       : this.companyNm,
                address         : this.address,
                zipCd           : this.zipCd,
                homeUrl         : this.homeUrl,
                contactFrstNm   : this.contactFrstNm,
                contactLastNm   : this.contactLastNm,
                contactEmail    : this.contactEmail,
                contactPhoneNo  : this.contactPhoneNo,
                apeCodes        : this.apeCodes,
                attachFile1Name : this.attachFile1Name,
                attachFile1Size : this.attachFile1Size,
                attachFile2Name : this.attachFile2Name,
                attachFile2Size : this.attachFile2Size
            };
            console.log('joinData ===> ', joinData);

            const url = `${SDLUtil.API_URL}/noauth/eur/joinUser.skp`;
            return await axios.post(url, 
                    qs.stringify(joinData), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(resp => {
                    SDLUtil.showLoadingBar(false);
                    console.log('login.resp.data ===> ', resp.data);
                    // 가입과 동시에 로그인 되게...
                    if (resp.data.isLogin) {
                        const userInfo = resp.data;
                        console.log('login.userInfo ===> ', userInfo);
                        store.commit('LOGIN_ID',    userInfo.bpNo);
                        store.commit('CORP_NO',     userInfo.corpNo);
                        store.commit('EMAIL',       this.email);
                        store.commit('COUNTRY_CD',  this.loginCountryCd);
                        store.commit('LANG_CD',     localStorage.getItem('eur.user.lang.code'));
                        localStorage.setItem('eurUser', 'Y');

                        SDLUtil.show(
                            ConfirmPopup, {
                                title: 'Join Information',
                                pParams: joinData,
                                rtnJoinFunc: arg1 => {
                                    this.goNextStep3();
                                }
                            }, // component params
                            {
                                height: 'auto',
                            } // dialog params
                        );
                    } else if (resp.data.resCode == '2') {
                        SDLUtil.alert('MESSAGE.EUR.DUPLICATE.EMAIL');
                    } else {
                        SDLUtil.alert(resp.data.resMsg);
                    }
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    console.log('Err.join ==> ', err);
                    SDLUtil.errorAlert(err);
                });
        },
        goBackStep1() {
            let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep1`;
            this.$router.push({ path: pathUrl, query: {}});
        },
        goNextStep3() {
            let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep3`;
            this.$router.push({ path: pathUrl, query: {}});
        },
        onlyNumber(e) { 
            SDLUtil.onlyNumber(e); 
        },
        onlyNumber2(e) { 
            SDLUtil.onlyNumber2(e); 
        },
        getCommonCodes(groupCd) {
            const url = `${SDLUtil.API_URL}/noauth/eur/getNationLangCodes.skp`;
            return axios.post(url, 
                qs.stringify({groupCd: groupCd}), {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(resp => {
                if (groupCd == 'N') { // Nations
                    this.countryCdList = resp.data.rows;
                } else if (groupCd == 'L') { // Languages
                    this.langCdList = resp.data.rows;
                }
            }).catch(err => {
                console.log('CommonCodes.Error occured : ', err);
            });
        },
        // 파일 업로드 (Excel)
        fileUpload(e, seq) {
            let oldFileName, oldFileSize;
            let bAllow1 = true;
            let files = e.target.files;
            if (files.length) {

                if (!SDLUtil.isPermitUploadFile(files[0].name)) {
                    $('#file' + seq).val('');
                    if (seq == 1) {
                        console.log('this.attachFile1Name(1) ==> ', this.attachFile1Name);
                        this.attachFile1Name = '';
                        console.log('this.attachFile1Name(2) ==> ', this.attachFile1Name);
                    } else {
                        $('#file' + seq).val('');
                        this.attachFile2Name = '';
                    }          
                    bAllow1 = false;
                    return bAllow1;
                }
                if (!bAllow1) return;

                SDLUtil.showLoadingBar(true);
                let formData = new FormData();
                formData.append('attachFile' + seq, files[0]);
                if (seq == 1) {
                    oldFileName = this.attachFile1Name;
                    oldFileSize = this.attachFile1Size;
                    $('.attachFile1').removeClass('error');
                    this.attachFile1Name = files[0].name;
                    this.attachFile1Size = files[0].size;
                } else if (seq == 2) {
                    oldFileName = this.attachFile2Name;
                    oldFileSize = this.attachFile2Size;
                    $('.attachFile2').removeClass('error');
                    this.attachFile2Name = files[0].name;
                    this.attachFile2Size = files[0].size;
                }

                axios.post(
                    `${SDLUtil.API_URL}/noauth/eur/fileUpload.skp`,
                    formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }
                ).then(resp => {
                    if (resp.data == '-1') {
                        SDLUtil.alert('MESSAGE.EUR.NO.PERMIT.FILE');
                    } else if (resp.data == '-2') {
                        SDLUtil.alert('MESSAGE.EUR.NO.FILE.NAME');
                    }
                    if (resp.data != '1') {
                        $('#file' + seq).val('');
                        if (seq == 1) {
                            this.attachFile1Name = oldFileName;
                            this.attachFile1Size = oldFileSize;
                            $('#idAttachFile1').val(oldFileName);
                            if (oldFileName.length == 0) $('.attachFile1').removeClass('active');
                        } else if (seq == 2) {
                            this.attachFile2Name = oldFileName;
                            this.attachFile2Size = oldFileSize;
                            let $inp_text = $(this).find("input:text")
                            $('#idAttachFile2').val(oldFileName);
                            if (oldFileName.length == 0) $('.attachFile2').removeClass('active');
                        }
                    }

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
            }
        },
        inputEvent() {
            // 필수정보
            var $inputs = $('.input-rows').find(':input');
            $inputs.each(function() {
                var $input = $(this),
                $label = $input.parent('div.one-input-container');
                if ($input.val())
                    $label.addClass('active');

                $input.focusin(function() {
                    $label.addClass('focus');
                    $label.siblings('div.flexbdy').addClass('off');
                });
                $input.change(function() {
                    $label.addClass('active');
                });
                $input.focusout(function() {
                    $label.removeClass('focus');
                    //if (!$input.val()) $label.removeClass('active').siblings('div.flexbdy').removeClass('off');
                });
            });

            // 첨부파일
            $(".file-input").each(function() {
                var $inp_file = $(this).find("input:file")
                var $inp_text = $(this).find("input:text")

                $inp_file.change("input", function() {
                    let bAllow = true;
                    var fullFile = $(this).val();
                    fullFile = fullFile.split('\\');
                    let fileName = fullFile[fullFile.length-1];

                    if (fileName && !SDLUtil.isPermitUploadFile(fileName)) {
                        bAllow = false;
                        return bAllow;
                    }
                    if (!bAllow) return;

                    $inp_text.val(fileName);

                    if ($inp_text.val().trim() == '') {
                        $(this).closest("div.file-input").removeClass('active');
                    } else {
                        $(this).closest("div.file-input").addClass('active');
                    }
                });
            });
        },
    },
    created() {
    },
    mounted() {
        this.countryNm = localStorage.getItem('eur.user.country.name');
        this.langNm    = localStorage.getItem('eur.user.lang.name');
        this.countryLangNm = this.countryNm + ' / ' + this.langNm;
        const agreeYn = localStorage.getItem('eurMyAgreeYn');
        this.$nextTick(() => {
            if (agreeYn != 'Y') {
                SDLUtil.alert({
                    title: 'WARNING',
                    msg: 'MESSAGE.EUR.WRONG.ACCESS',
                    onOkEvt: () => {
                        let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`;
                        this.$router.push({ path: pathUrl, query: {}});
                    }
                });
            }
        });

        if (this.guid && this.loginCountryCd && this.email) {
            this.$nextTick(() => {
                this.inputEvent();
                this.$refs.compNm.focus();
            });
            store.commit('LANG_CD', this.langCd);
            loadLanguageAsync(this.langCd);
        } else {
            this.$nextTick(() => {
                SDLUtil.alert({
                    msg: 'MESSAGE.SESSION.HAS.EXPIRED',
                    onOkEvt: () => {
                        let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`;
                        this.$router.push({ path: pathUrl, query: {}});
                    }
                });
            });
        }
    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/JoinUserStep2.vue